import {
  CREATE_WEBSITE_QUERY_QUEUE,
  FETCH_WEBSITE_QUERY_QUEUE_LIST,
  UPDATE_WEBSITE_QUERY_QUEUE,
  ASSIGN_TO_WEBSITE_QUERY_QUEUE,
} from "./types";

export const fetchWebsiteQueryQueues = (payload:{page:number}) => {
  return {
    type: FETCH_WEBSITE_QUERY_QUEUE_LIST,
    payload,
  };
};

export const createWebsiteQueryQueue = (payload: any) => {
  return {
    type: CREATE_WEBSITE_QUERY_QUEUE,
    payload,
  };
};

export const updateWebsiteQueryQueue = (payload: any) => {
  return {
    type: UPDATE_WEBSITE_QUERY_QUEUE,
    payload,
  };
};

export const assignToWebsiteQueryQueue = (payload: any) => {
  return {
    type: ASSIGN_TO_WEBSITE_QUERY_QUEUE,
    payload,
  };
};
